/* ============================================================
   KĀRU · Set-Picker — Scroll-Verhalten (Progressive Enhancement)

   1) Auto-Fokus: die aktive Karte ("Deine Wahl", aria-current)
      wird beim Laden im Slider zentriert (ohne Animation).
   2) Swipe-Affordance nach UI/UX-Best-Practice: Edge-Fades +
      tippbare Chevron-Buttons, die an den Scroll-Enden
      automatisch verschwinden. Ohne JS bleibt der Slider ein
      normaler Scroller mit angeschnittener Karte (Peek).
   ============================================================ */

(function () {
  'use strict';

  if (window.customElements && customElements.get('set-picker-scroller')) return;

  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* egal */ }

  class SetPickerScroller extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.track = this.querySelector('[data-sp-track]');
      if (!this.track) return;

      var self = this;

      this._raf = 0;
      this.track.addEventListener('scroll', function () {
        if (self._raf) return;
        self._raf = requestAnimationFrame(function () {
          self._raf = 0;
          self.refresh();
        });
      }, { passive: true });

      this.querySelectorAll('[data-sp-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-sp-nav') === 'prev' ? -1 : 1;
          var step = Math.max(self.track.clientWidth * 0.7, 120);
          self.track.scrollBy({ left: dir * step, behavior: REDUCED ? 'auto' : 'smooth' });
        });
      });

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(function () { self.refresh(); });
        this._ro.observe(this.track);
      } else {
        window.addEventListener('resize', function () { self.refresh(); });
      }

      // Aktive Option initial in den Fokus (instant, kein Motion beim Laden)
      var current = this.track.querySelector('[aria-current="true"]');
      if (current) {
        var t = this.track;
        var max = t.scrollWidth - t.clientWidth;
        if (max > 4) {
          var delta = current.getBoundingClientRect().left - t.getBoundingClientRect().left;
          var left = t.scrollLeft + delta - (t.clientWidth - current.offsetWidth) / 2;
          t.scrollLeft = Math.max(0, Math.min(left, max));
        }
      }

      this.refresh();
    }

    disconnectedCallback() {
      if (this._ro) { this._ro.disconnect(); this._ro = null; }
    }

    refresh() {
      var t = this.track;
      if (!t) return;
      var max = t.scrollWidth - t.clientWidth;
      this.classList.toggle('has-prev', max > 4 && t.scrollLeft > 4);
      this.classList.toggle('has-next', max > 4 && t.scrollLeft < max - 4);
    }
  }

  customElements.define('set-picker-scroller', SetPickerScroller);
})();
